<template>
    <div>

        <div class="card card-body">

            <div class="table-filters">
                <div class="row justify-content-between">
                    <div class="col-sm-12">
                        <div class="form-inline">
                            <div class="btn-group mr-1 mt-1">
                                <button type="button" class="btn btn-primary dropdown-toggle"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ currentEventTypeFilter }}
                                </button>
                                <div class="dropdown-menu">
                                    <a v-for="eventType in eventTypes" class="dropdown-item"
                                       @click="selectEventTypeFilter(eventType)">{{ eventType }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="selectEventTypeFilter('All')">All</a>
                                </div>
                            </div>
                            <div class="input-group mt-1 mr-1">
                                <input type="text"
                                       v-model="filterText"
                                       @keyup.enter="doFilter"
                                       placeholder="Search audit events"
                                       class="form-control">
                                <div class="input-group-append">
                                    <button class="btn btn-primary" type="button" @click="doFilter">
                                        Search
                                    </button>
                                </div>
                            </div>
                            <div class="input-group mt-1">
                                <el-date-picker
                                        v-model="dateRangeFilter"
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        unlink-panels
                                        start-placeholder="Start date"
                                        end-placeholder="End date"
                                        :picker-options="datePickerOptions"
                                        @change="dateRangeSelected">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <table class="table table-responsive audit-table">

                <thead>
                <tr>
                    <th style="min-width: 150px">Timestamp</th>
                    <th style="min-width: 150px">User</th>
                    <th>Event</th>
                    <th style="min-width: 300px">Tags</th>
                    <th class="audit-description-column">Audit</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="audit in audits" :key="audit.id">

                    <td>{{audit.created_at | datetime}}</td>
                    <td>{{audit.user_name}}</td>
                    <td>
                        <span class="label"
                              :class="[audit.event === 'deleted' ? 'label-light-danger' : 'label-light-primary']">{{audit.event | capitalize}}</span>
                    </td>
                    <td class="audit-tags">
                        <small v-for="tag in auditTags(audit)" class="font-weight-bold p-1 mr-2"
                               style="background: #efefef; border-radius: 4px;">
                            {{tag}}
                        </small>
                    </td>
                    <td class="audit-description-column">
                        <p class="audit-summary" v-html="auditChangesDescription(audit)"></p>
                    </td>
                </tr>
                </tbody>

            </table>
        </div>

    </div>
</template>

<script>

    export default {

        props: ["url"],

        data () {
            return {
                audits: {},
                eventTypes: ["Created", "Updated", "Deleted"],
                filterText: "",
                currentEventTypeFilter: "All",
                dateRangeFilter: "",
                datePickerOptions: {
                    shortcuts: [{
                        text: "Last week",
                        onClick (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    }, {
                        text: "Last month",
                        onClick (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    }, {
                        text: "Last 3 months",
                        onClick (picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }]
                },
            };
        },

        mounted () {

            Bus.$on("show-audit", function () {
                $("#audit-modal").modal("show");
            });

            this.fetchAudits();
        },

        methods: {

            auditTags (audit) {
                if (_.isArray(audit.tags)) {
                    return audit.tags;
                }
                return audit.tags.split(",");
            },

            auditChangesDescription (audit) {
                let self = this;
                let message = "";

                if (audit.event === "deleted") {

                    Object.keys(audit.old_values).forEach(function (val, index) {
                        if (self.shouldShowAuditValue(val)) {
                            message += self.formatAttributeName(val) + " <strong>" + self.parseAuditValue(audit.old_values[val]) + "</strong>. ";
                        }
                    });

                    return message;

                }

                Object.keys(audit.new_values).forEach(function (val, index) {
                    if (self.shouldShowAuditValue(val)) {
                        if (audit.old_values[val]) {
                            message += self.formatAttributeName(val) + " changed from <strong>" + self.parseAuditValue(audit.old_values[val]) + "</strong> to <strong>" + self.parseAuditValue(audit.new_values[val]) + "</strong>. ";
                        } else {
                            message += self.formatAttributeName(val) + " <strong>" + self.parseAuditValue(audit.new_values[val]) + "</strong>. ";
                        }
                    }
                });

                return message;
            },

            parseAuditValue (val) {

                if (_.isEmpty(val)) {
                    return "Empty";
                }

                if (_.isNumber(val)) {
                    return _.round(val, 2);
                }

                if (_.isObject(val) && val.date !== undefined) {
                    return moment.utc(val.date).local().format("D MMM YYYY h:mm A");
                }

                return val;

            },

            shouldShowAuditValue (val) {
                return !val.includes("id");
            },

            formatAttributeName (val) {
                return _.startCase(val);
            },

            fetchAudits () {

                axios.get(this.url, {
                    params: {
                        filter: this.filterText,
                        eventType: this.currentEventTypeFilter,
                        dateRange: this.dateRangeFilter
                    }
                })
                .then(response => {
                    this.audits = response.data;
                })
                .catch(errors => {
                    toastr.error(errors.message);
                });

            },

            selectEventTypeFilter (type) {
                this.currentEventTypeFilter = type;
                this.fetchAudits();
            },

            dateRangeSelected (min, max) {
                this.fetchAudits();
            },

            doFilter () {
                this.fetchAudits();
            }

        }

    };

</script>

<style scoped>

    .audit-table th, .audit-table td {
        padding: 0.3rem;
        font-size: 12px;
    }

    .audit-summary {
        font-size: 12px;
        margin: 0px;
    }

    .audit-description-column {
        min-width: 200px;
        width: 100%;
    }

    .el-date-editor .el-range-separator {
        width: 30px !important;
    }

    .el-range-editor.el-input__inner {
        padding: 1px 10px;
    }

    .el-input__inner {
        height: 36px;
        line-height: 36px;
    }

    .audit-tags {
    }

</style>